import React, {useEffect, useState} from 'react';
import localStrings from "../../localStrings";
import useAuth from "../../hooks/useAuth";
import moment from "moment/moment";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import {DataGridPremium} from "@mui/x-data-grid-premium";
import {Box, Typography} from "@mui/material";
import {filterSingleDay} from "../Home/FilterInfoOverview";
import CenterMessage from "../../components/messages/CenterMessage";
import {ThemeProvider} from "@mui/material/styles";
import {dataGridTheme} from "./index";

function DetailGridView() {

    const [formattedOrders, setFormattedOrders] = React.useState(null);

    const columns = [
        {
            field: 'seqId',
            headerName: localStrings.sequId,
            width: 155
        },
        {
            field: 'start_time',
            headerName: localStrings.startTime,
            width: 155,
        },
        {
            field: 'end_time',
            headerName: localStrings.end_time,
            width: 155,
        },
        {
            field: 'staff_name',
            headerName: localStrings.staff,
            width: 100,
        },
        {
            field: 'nb_seats',
            headerName: localStrings.nb_seats,
            type: 'number',
            width: 155,
        },
        {
            field: 'table_name',
            headerName: localStrings.table_name,
            width: 155
        },

        {
            field: 'payment_types',
            headerName: localStrings.payment_types,
            width: 155,
        },

        {
            field: 'taxesRaw',
            headerName: localStrings.totalTaxes,
            width: 120,
            type: 'number',
        },

        {
            field: 'totalWithTaxRaw',
            headerName: localStrings.totalWithTax,
            width: 155,
            type: 'number',
        },

        {
            field: 'location',
            headerName: localStrings.location,
            width: 120,
        },

        {
            field: 'productSalesCount',
            headerName: localStrings.productSalesCount,
            width: 155,
            type: 'number',
        },

        {
            field: 'productOptionsCount',
            headerName: localStrings.productOptionsCount,
            width: 175,
            type: 'number',
        },


    ];

    const { filter, orders, loading, loadingData} = useAuth()

    function getTitle() {
        if (orders && orders.length > 0) {
            return localStrings.formatString(localStrings.accountingDetail,
                moment(orders[0].start_time).format("llll"),
                moment(orders[orders.length - 1].end_time).format("llll"),
            );
        }
        return localStrings.accounting;
    }

    useEffect(() => {
            let ordersFormatted = (orders || []).map(order => {
                return {
                    ...order,
                    nb_seats: parseFloat(order.nb_seats || 0),
                    totalWithTaxRaw: parseFloat(order.totalWithTaxRaw || 0),
                    taxesRaw: parseFloat(order.taxesRaw || 0),
                    start_time: moment(order.start_time).format('YYYY-MM-DD HH:mm:ss'),
                    end_time: moment(order.end_time).format('YYYY-MM-DD HH:mm:ss'),
                    staff_name: order.staff?.staff_name || '',
                    table_name: order.table?.table_name || '',
                    payment_types: (order.payments || []).map(pay => pay.name).sort().join(', '),
                    location: order.location?.location_name || '',
                    productSalesCount: (order.items || []).length,
                    productOptionsCount: (order.items || [])
                        .reduce((acc, item) => {
                            return acc + (item.options || []).length;
                        }, 0)
                }
            })
            setFormattedOrders(ordersFormatted);

        },
        [orders, filter]);

    function DetailPanelContentInner({ row: rowProp }) {
        return (
            <Stack
                sx={{ boxSizing: 'border-box' }}
                direction="column"
            >

                <Paper sx={{ flex: 1, mx: 'auto', width: '90%', p: 1 }}>
                    <DataGridPremium
                        density="compact"
                        columns={[
                            {
                                field: 'option_list_name',
                                headerName: localStrings.optionName,
                                flex: 1
                            },
                            {
                                field: 'priceRaw',
                                headerName: localStrings.price,
                                flex: 1,
                                type: 'number',
                            },
                            {
                                field: 'quantity',
                                headerName: localStrings.quantity,
                                flex: 1,
                                type: 'number',
                            },

                        ]}
                        rows={(rowProp.options || []).map((item, key) => {
                            return {
                                id: key,
                                ...item,
                            }
                        })}
                        sx={{ flex: 1 }}
                        hideFooter
                    />
                </Paper>
            </Stack>
        );

    }

    function DetailPanelContent({ row: rowProp }) {
        return (
            <Stack
                sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
                direction="column"
            >

                <Paper sx={{ flex: 1, mx: 'auto', width: '90%', p: 1 }}>
                    {/*<p>{JSON.stringify(rowProp)}</p>*/}
                    <Stack direction="column" spacing={1} sx={{ height: 1, width: '100%' }}>
                        <Typography variant="h6">{localStrings.formatString(localStrings.orderItemDisplay, rowProp.seqId)}</Typography>
                        <Typography variant="body1">{
                            localStrings.formatString(localStrings.tableNameDisplay, rowProp.table?.table_name || '')}</Typography>
                        <Typography variant="body1">{
                            localStrings.formatString(localStrings.staffNameDisplay, rowProp.staff?.staff_name || '')}</Typography>
                        <DataGridPremium
                            density="compact"
                            columns={[
                                {
                                    field: 'product_name',
                                    headerName: localStrings.productName,
                                    flex: 1
                                },
                                {
                                    field: 'priceRaw',
                                    headerName: localStrings.price,
                                    flex: 1
                                },
                                {
                                    field: 'quantity',
                                    headerName: localStrings.quantity,
                                    flex: 1
                                },
                                {
                                    field: 'productOptionsCount',
                                    headerName: localStrings.productOptionsCount,
                                    flex: 1
                                },

                            ]}
                            getDetailPanelHeight={() => 'auto'}
                            getDetailPanelContent={DetailPanelContentInner}
                            rows={rowProp.items.map((item, key) => {
                                return {
                                    id: key,
                                    ...item,
                                    productOptionsCount: (item.options || []).length,
                                }
                            })}
                            sx={{ flex: 1 }}
                            hideFooter
                        />
                    </Stack>
                </Paper>
            </Stack>
        );
    }

    const getDetailPanelContent = React.useCallback(
        ({ row }) => <DetailPanelContent row={row} />,
        [],
    );

    return (
        <div>
            {orders && orders.length > 0 &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-end',
                        gap: 2, // espace horizontal entre chaque bloc
                    }}
                >
                    <Box>
                        <Typography variant="body1" color="primary.main">
                            {moment(orders[0].start_time).format("dddd, DD MMMM YYYY")}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" color="secondary.main">
                            {moment(orders[0].start_time).format("HH:mm:ss")}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body1" color="text.secondary">
                            /
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body1" color="primary.main">
                            {moment(orders[orders.length - 1].end_time).format("dddd, DD MMMM YYYY")}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" color="secondary.main">
                            {moment(orders[orders.length - 1].end_time).format("HH:mm:ss")}
                        </Typography>
                    </Box>
                </Box>

            }

            {filter?.filterType !== filterSingleDay &&
                <CenterMessage
                    // height={chartImplementation.height || 350}
                    message={localStrings.onlyAvailableInSingleDayMode}
                />
            }

            {formattedOrders && orders && filter?.filterType === filterSingleDay &&
                <div style={{height: 'calc(100vh - 160px)', width: '100%'}}>
                    <ThemeProvider theme={dataGridTheme}>
                        <DataGridPremium
                            // initialState={initialState}
                            rows={formattedOrders || []}
                            columns={columns}
                            showToolbar
                            getDetailPanelHeight={() => 'auto'}
                            getDetailPanelContent={getDetailPanelContent}
                            loading={loadingData}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: false,
                                },
                            }}
                            sx={{
                                margin: 'none',
                                '& .MuiDataGrid-row': {
                                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                                },
                                '& .MuiDataGrid-toolbarContainer': {
                                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                                    paddingBottom: 1,
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 'bold',
                                },
                            }}
                        />
                    </ThemeProvider>
                </div>
            }
        </div>
    )
}

export default DetailGridView